import script from "./ScrollableTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScrollableTable.vue?vue&type=script&lang=ts&setup=true"

import "./ScrollableTable.vue?vue&type=style&index=0&id=a4039ed0&lang=scss"

const __exports__ = script;

export default __exports__